<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.25 4C7.69328 4 4 7.69328 4 12.25C4 16.8058 7.69336 20.5 12.25 20.5C16.8057 20.5 20.5 16.8057 20.5 12.25C20.5 7.69336 16.8058 4 12.25 4ZM2 12.25C2 6.58872 6.58872 2 12.25 2C17.9102 2 22.5 6.58864 22.5 12.25C22.5 17.9103 17.9103 22.5 12.25 22.5C6.58864 22.5 2 17.9102 2 12.25Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2451 7.4541C12.7974 7.4541 13.2451 7.90181 13.2451 8.4541V12.8731C13.2451 13.4254 12.7974 13.8731 12.2451 13.8731C11.6928 13.8731 11.2451 13.4254 11.2451 12.8731V8.4541C11.2451 7.90181 11.6928 7.4541 12.2451 7.4541Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2449 16.046C11.2449 15.4937 11.6926 15.046 12.2449 15.046H12.2549C12.8072 15.046 13.2549 15.4937 13.2549 16.046C13.2549 16.5983 12.8072 17.046 12.2549 17.046H12.2449C11.6926 17.046 11.2449 16.5983 11.2449 16.046Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
